import React, { useMemo } from 'react';
import { MenuItem } from '@material-ui/core';
import FormTextField from './FormTextField';
export const FormSelectField = ({ stateNode, element, edit, disabled, value, onChange }) => {
    const options = useMemo(() => {
        var _a;
        return (((_a = element.config) === null || _a === void 0 ? void 0 : _a.options) || []).map(o => ['string', 'number', 'boolean'].includes(typeof o)
            ? { value: o, label: o.toString() }
            : o);
    }, [element.config]);
    return (React.createElement(FormTextField, { select: true, value: value, stateNode: stateNode, edit: edit, disabled: disabled, element: element, onChange: onChange }, options.map((option, index) => (React.createElement(MenuItem, { key: index, value: option.value }, option.label)))));
};
export default FormSelectField;
//# sourceMappingURL=FormSelectField.js.map